export default __webpack_public_path__ + "static/media/i-vin_connect.1d08d095.svg";